import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { DeleteReturnComments } from "../../../Redux/Reducers/ReportStage/ReturnComments";
import NoteForm from "./NoteForm";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import loadConfig from "../../../Services/Api/ApiServices";
import TableAHSF from "../../../Components/TableAHSF";

const NoteTable = (props) => {
  const AddNote = useSelector(
    (state) => state.ReturnComments.AddReturnComments
  );

  const [jsonData, setJsonData] = useState({});

  const [returnCommentsId, setreturnCommentsId] = useState(null);

  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "comments",
      ShowStatus: true,
      NmaeColumn: "الملاحظة",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "formattedCreateTime",
      ShowStatus: true,
      NmaeColumn: "تاريخ الملاحظة",
      TotalNumber: false,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);

        setreturnCommentsId(objects.returnCommentsId);
        setPopUpBodyStatus(true);

        console.log(objects, "objects");
      },
      content: "",
      className: "",
      id: "editBtn",
      title: "تعديل",
      ShowStatus: true,
      InitialScreeningAssessment: true,
    },
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);
        var returnCommentsId = objects.returnCommentsId;

        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteReturnComments({
                returnCommentsId: returnCommentsId,
              })
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: true,
      // ShowStatus: true,
      //   !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <NoteForm reportStageId={props.reportStageId} />,

    title: "الملاحظات",
    maxWidth: "500px",
    maxHeight: "500px",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

//   const popUpBody = {
//     isPopupOpenStatus: popUpBodyStatus,
//     isPopupOpenFunction: () => {
//       setPopUpBodyStatus(false);
//     },

//     componentBody: (
//       <ActivitesForm
//         Action="edit"
//         activitiesObjectivesId={returnCommentsId}
//         reportId={props.reportId}
//       />
//     ),

//     title: "الانشطة",
//     maxWidth: "500px",
//     maxHeight: "500px",
//     idssss: "SecondarySectors",
//   };

  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [AddNote]);

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        RequestsManagerValue={true}
        AllValueAction={true}
        uniqueValue={"returnCommentsId"}
        valueButtonAction={"returnCommentsId"}
        URL={`api/ReturnComments/ReturnCommentsList`}
        UrlBody={{
          reportStageId: props.reportStageId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={true}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"taskId"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        uniqeKeyNameRedux={"tasksList"}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody={
        //   <PopupAHSF
        //     idssss="SecondarySectors"
        //     isPopupOpenStatus={popUpBody.isPopupOpenStatus}
        //     isPopupOpenFunction={popUpBody.isPopupOpenFunction}
        //     title={popUpBody.title}
        //     componentBody={popUpBody.componentBody}
        //     maxWidth={popUpBody.maxWidth}
        //     maxHeight={popUpBody.maxHeight}
        //   />
        // }
      />
    </>
  );
};

export default NoteTable;
